import React from 'react';
import { User } from 'fearless-common';
import {adminRoutes} from "../../../utils/routes";
import Pages from "../../../components/layout/Pages";
import OrderableTable from "../../../components/layout/OrderableTable";
import useTitle from "../../../components/hooks/useTitle";
import {ColumnDef} from "@tanstack/react-table";
import {Button} from 'fearless-common-ui';
import {PlusLg} from "react-bootstrap-icons";
import CellRender from "../../../components/layout/table/CellRender";

type ApiNotification = {
    id: number;
    type: string;
    notifiable: User;
    data: any;
    created_at: string;
    read_at: string | null;
}

const columns: ColumnDef<ApiNotification>[] = [
  { id: 'created_at', accessorKey: 'created_at', header: 'Send at', cell: CellRender.DateTime, enableSorting: true, },
  { id: 'notifiable', accessorKey: 'notifiable', header: 'Recipient', cell: CellRender.FullName, enableSorting: false },
  { id: 'type', accessorKey: 'type', header: 'Type', enableSorting: false },
  { id: 'read_at', accessorKey: 'read_at', header: 'Read', cell: CellRender.DateTime, enableSorting: false, },
]

/**
 * Shows a table of users in the Admin environment.
 */
export default function AdminNotifications() {

    useTitle(`Admin Notifications`);

    return (
        <Pages.Base padded className="px-3">
            <div className="d-flex align-items-center">
                <h1 className="mb-0 me-3">Notifications</h1>
                <div className="flex-grow-1">
                    <Button href={adminRoutes.sendNotification}>
                        <PlusLg /> send HTML notification
                    </Button>
                </div>
            </div>
            <OrderableTable
                filterables={[
                    {
                        field_name: 'read_at',
                        label: 'Read',
                        options: [
                            { value: 'null', label: 'Unread' },
                            { value: 'not null', label: 'Read' },
                        ],
                    },
                ]}
                baseEndpoint={'/admin/notifications?_with[]=notifiable'}
                memoisedColumns={columns}
                pagination
            />
        </Pages.Base>
    );
}
